import { Box, ClickAwayListener, Typography } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const minCoinsRequired = 100;
export const useNotEnoughCoins = () => {
  const coins = useSelector((state: any) => state.userReducer.coins);
  const hasEnoughCoins = coins >= minCoinsRequired;
  const [showCoinsMessage, setShowCoinsMessage] = useState(false);

  const checkIfEnoughCoins = useCallback(() => {
    if (hasEnoughCoins) return;
    setShowCoinsMessage(true);
  }, [hasEnoughCoins]);

  return {
    showCoinsMessage,
    checkIfEnoughCoins,
    hasEnoughCoins,
    setShowCoinsMessage,
  };
};

interface NotEnoughCoinsProps {
  readonly showCoinsMessage: boolean;
  readonly setShowCoinsMessage: (value: boolean) => void;
}

export const NotEnoughCoins: FC<NotEnoughCoinsProps> = ({
  showCoinsMessage,
  setShowCoinsMessage,
}) => {
  if (!showCoinsMessage) return null;

  return (
    <ClickAwayListener
      onClickAway={() => {
        setShowCoinsMessage(false);
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          color: 'white',
          padding: '24px',
          borderRadius: '12px',
          zIndex: 9999,
          maxWidth: '90%',
          textAlign: 'center',
          animation: 'fadeInOut 4s ease-in-out',
          border: '2px solid #ff6b6b',
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: '12px', fontWeight: 'bold' }}
        >
          ⚠️ Insufficient Coins
        </Typography>
        <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
          You don't have enough coins. You need {minCoinsRequired} coins to
          start a match.
          <br />
          <span
            style={{
              marginTop: '8px',
              display: 'inline-block',
              color: '#ffd700',
            }}
          >
            Claim your free Daily deal to top up.
          </span>
        </Typography>
      </Box>
    </ClickAwayListener>
  );
};
